import FeatureCard from "./feature-card";
import { memo, useMemo } from "react";
import React from "react";
import { BookOpenCheck, Drama, MessageCircleQuestion, ShieldAlert, WandSparkles } from "lucide-react";


const featuresCategories = [
  {
    key: "examples",
    title: "Follow-Ups",
    // make icon stroke less wide
    icon: <MessageCircleQuestion width={40} height={40} className="stroke-1" />,
    descriptions: [
      "What follow-ups refine this assessment further?",
      "Which root causes explain these gaps, exceptions?",
      "Update policies for Splunk adoption.",
    ],
  },
  {
    key: "capabilities",
    title: "Knowledge",
    icon: <BookOpenCheck width={40} height={40} className=" stroke-1" />,
    descriptions: [
      "How does NIST AI RMF relate to CSF?",
      "What are each category’s and overall maturity tiers?",
      "What is a SIEM?",
    ],
  },
  {
    key: "limitations",
    title: "Benchmarks",
    icon: <ShieldAlert width={40} height={40} className=" stroke-1" />,
    descriptions: [
      "Which peers share a similar risk profile?",
      "What attacks are most prevalent in Kubernettes",
      "Have there been phishing attacks on companies like ours?",
    ],
  },
];

interface FeaturesCardsProps {
  className?: string;
  cardClassName?: string;
}

function FeaturesCards({ className, cardClassName }: FeaturesCardsProps) {
  const cards = useMemo(() => {
    // Pre-compute expensive icon renders and cache them
    const processedCategories = featuresCategories.map((category) => ({
      ...category,
      processedIcon: React.cloneElement(category.icon, { 
        key: `icon-${category.key}`,
        'aria-hidden': true 
      })
    }));
    
    return processedCategories.map((category) => (
      <FeatureCard
        className={cardClassName}
        key={category.key}
        descriptions={category.descriptions}
        icon={category.processedIcon}
        title={category.title}
      />
    ));
  }, [cardClassName]);

  return <div className={className}>{cards}</div>;
}

export default memo(FeaturesCards);
